<template>
  <q-dialog v-model="show" persistent>
    <q-card class="padding-horizontal-medium">
      <q-toolbar>
        <q-toolbar-title><span class="text-weight-bold">Suppression</span> d'une boisson</q-toolbar-title>
        <q-btn flat round dense icon="close" @click="$emit('close')" />
      </q-toolbar>

      <q-card-section>
        <div class="text-h6">Voulez-vous supprimer la boisson : {{drink.name}} ?</div>
      </q-card-section>


      <q-card-section>
        <p>Nom : {{drink.name}}</p>
        <p>Prix de départ : {{drink.start_price}}</p>
        <p>Prix minimum : {{drink.lower_price}}</p>
        <p>Prix maximum : {{drink.higher_price}}</p>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn label="Annuler" color="secondary" flat class="q-ml-sm" @click="$emit('cancel')" cypress="cancelDrinkButton"/>
        <q-btn label="Supprimer" color="red" flat @click="$emit('delete')" cypress="deleteDrinkButton"/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
export default {
  name: "DeleteDrinkDialog",
  props: {
    show: Boolean,
    drink: Object,
  },
}
</script>
